import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../../services/popup.service';
import { ContactService } from '../../services/contact.service';

@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrl: './get-in-touch.component.scss',
  standalone: false,
})
export class GetInTouchComponent {

  private readonly fb = inject(FormBuilder);
  private readonly popupService = inject(PopupService);
  private readonly translate = inject(TranslateService);
  private readonly contactService = inject(ContactService);

  readonly form = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', Validators.required],
    subject: ['', Validators.required],
    message: ['', Validators.required],
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.popupService.messsageAlert('error', this.translate.instant('get_in_touch.error_message'));
      return;
    }
    this.sendEmail(this.form.value as Record<string, unknown>);
  }

  async sendEmail(formValue: Record<string, unknown>) {
    try {
      const data = await this.contactService.submitContactForm(formValue);

      if (data.result === 'success') {
        this.popupService.messsageAlert('success', this.translate.instant('get_in_touch.success_message'));
        this.form.reset();
      } else {
        this.popupService.messsageAlert('error', this.translate.instant('get_in_touch.error_message'));
      }
    } catch (error) {
      this.popupService.messsageAlert('error', this.translate.instant('get_in_touch.error_message'));
    }
  }
}
